export default __webpack_public_path__ + "static/media/docDarkLogo.fa948cbe.svg";